module.exports = __webpack_public_path__ + "assets/img/rgt.a1af4e36.png";